import { render } from "./AMLDashboardResults.vue?vue&type=template&id=3ea5961d"
import script from "./AMLDashboardResults.vue?vue&type=script&lang=js"
export * from "./AMLDashboardResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__